import { render, staticRenderFns } from "./yuanquxuanze.vue?vue&type=template&id=80f1e230&scoped=true"
import script from "./yuanquxuanze.vue?vue&type=script&lang=js"
export * from "./yuanquxuanze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f1e230",
  null
  
)

export default component.exports